import React from 'react';
import {
  MessageCircle,
  MessageCircleHeart,
  FileText,
  Users,
  Mail,
  Group,
  User,
  UserRound,
  Stethoscope,
  LogOut,
  ArrowLeft,
  Settings,
  RefreshCw,
  Archive,
  AlertTriangle,
  X,
  Send,
  Calendar,
  Phone,
  ChevronRight,
  Loader2,
  Star,
  AlertCircle,
  Lightbulb,
  Zap,
  Eye,
  EyeOff,
  Plus,
  Minus,
  Check,
  CheckCircle,
  XCircle,
  Info,
  Heart,
  HeartPulse,
  TrendingUp,
  BarChart3,
  Clock,
  Download,
  Upload,
  Search,
  Filter,
  Home,
  Menu,
  MoreHorizontal,
  Edit,
  Trash2,
  Copy,
  Share,
  Lock,
  Unlock,
  Shield,
  Bell,
  BellOff,
  ChevronDown,
  FileCheck,
  BadgeCheck,
  CreditCard,
  IdCard,
  House,
  HelpCircle,
  Mic,
  Pause,
  Volume2,
  MicOff,
  Armchair,
  Video,
  Smile,
  Compass,
  Wrench,
  SquareLibrary,
  Settings2,
  BotMessageSquare,
  Save,
  Key,
  UserCog,
  Pencil,
  Brain,
  LockKeyhole,
  Bot,
  Activity,
  Pill,
  ClipboardList,
  Target,
  Circle,
  ShieldCheck,
  BookOpen,
  Sunrise,
  UserPlus,
  Diamond,
  Gem,
  Globe,
  GraduationCap,
  ExternalLink
  
  
} from 'lucide-react';

const iconMap = {
  // Communication
  'message-circle': MessageCircle,
  'message-circle-heart': MessageCircleHeart,
  'chat': MessageCircle,
  'chat-heart': MessageCircleHeart,
  'mail': Mail,
  'send': Send,
  
  // Navigation & Actions
  'arrow-left': ArrowLeft,
  'chevron-down': ChevronDown,
  'back': ArrowLeft,
  'refresh': RefreshCw,
  'refresh-cw': RefreshCw,
  'settings': Settings,
  'menu': Menu,
  'more': MoreHorizontal,
  'home': Home,
  'house': House,
  'logout': LogOut,
  'x': X,
  'close': X,
  'plus': Plus,
  'minus': Minus,
  'check': Check,
  'edit': Edit,
  'trash': Trash2,
  'copy': Copy,
  'share': Share,
  'search': Search,
  'filter': Filter,
  'download': Download,
  'upload': Upload,
  'compass': Compass,
  'wrench': Wrench,
  'square-library': SquareLibrary,
  'settings-2': Settings2,
  'bot-message-square': BotMessageSquare,
  'bot':Bot,
  
  // Legal & Compliance
  'file-check': FileCheck,
  'badge-check': BadgeCheck,
  'id-card': IdCard,
  'card': CreditCard,
  'identity': CreditCard,
  'credit-card': CreditCard,
  
  // Users & People
  'group': Group,
  'user': User,
  'user-plus': UserPlus,
  'user-round': UserRound,
  'users': Users,
  'stethoscope': Stethoscope,
  'therapist': Stethoscope,
  'smile': Smile,
  
  // Documents & Data
  'file-text': FileText,
  'document': FileText,
  'sessions': FileText,
  'archive': Archive,
  'calendar': Calendar,
  'clock': Clock,
  
  // Status & Feedback
  'check': Check,
  'check-circle': CheckCircle,
  'CheckCircle': CheckCircle,
  'x-circle': XCircle,
  'XCircle': XCircle,
  'alert': AlertTriangle,
  'alert-triangle': AlertTriangle,
  'warning': AlertTriangle,
  'alert-circle': AlertCircle,
  'info': Info,
  'loader': Loader2,
  'loading': Loader2,
  'spinner': Loader2,
  'circle-question-mark': HelpCircle,
  'help-circle': HelpCircle,
  'question': HelpCircle,
  'help': HelpCircle,
  
  // Medical & Therapy
  'lightbulb': Lightbulb,
  'insight': Lightbulb,
  'zap': Zap,
  'breakthrough': Zap,
  'brain': Brain,
  'ai': Brain,
  'intelligence': Brain,
  'activity': Activity,
  'pill': Pill,
  'clipboard-list': ClipboardList,
  'target': Target,
  'circle': Circle,
  'heart': Heart,
  'heart-pulse': HeartPulse,
  'book-open': BookOpen,
  'sunrise': Sunrise,
  
  // Visibility
  'eye': Eye,
  'eye-off': EyeOff,
  'show': Eye,
  'hide': EyeOff,
  
  // Communication & Collaboration
  'phone': Phone,
  'armchair': Armchair,
  'video': Video,
  
  // Charts & Analytics
  'trending-up': TrendingUp,
  'chart': BarChart3,
  'analytics': BarChart3,
  'bar-chart': BarChart3,
  
  // Security
  'lock': Lock,
  'unlock': Unlock,
  'shield': Shield,
  'shield-check': ShieldCheck,
  'security': Shield,
  'lock-keyhole': LockKeyhole,
  'keyhole': LockKeyhole,
  
  // Notifications
  'bell': Bell,
  'bell-off': BellOff,
  'notification': Bell,
  
  // Arrows & Direction
  'chevron-right': ChevronRight,
  'arrow-right': ChevronRight,

  //Sound
  'mic': Mic,
  'pause': Pause,
  'volume-2': Volume2,
  'mic-off': MicOff,
  
  // Profile & User Management
  'save': Save,
  'key': Key,
  'user-cog': UserCog,
  'profile': UserCog,
  'pencil': Pencil,
  
  // Premium & Currency
  'diamond': Diamond,
  'gem': Gem,
  'premium': Diamond,
  'credits': Diamond,
  
  // Education & Global
  'graduation-cap': GraduationCap,
  'globe': Globe,
  'external-link': ExternalLink,
  'link': ExternalLink
};

const Icon = ({ 
  name, 
  size = 16, 
  color = 'currentColor', 
  className = '',
  strokeWidth = 2,
  ...props 
}) => {
  const IconComponent = iconMap[name];
  
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found. Available icons:`, Object.keys(iconMap));
    return <AlertCircle size={size} color={color} className={className} strokeWidth={strokeWidth} {...props} />;
  }
  
  return (
    <IconComponent 
      size={size} 
      color={color} 
      className={className}
      strokeWidth={strokeWidth}
      {...props} 
    />
  );
};

// Helper component for loading/spinner with animation
export const LoadingIcon = ({ size = 16, className = '' }) => (
  <Icon 
    name="loading" 
    size={size} 
    className={`animate-spin ${className}`} 
  />
);

// Helper component for status indicators
export const StatusIcon = ({ status, size = 16, className = '' }) => {
  const statusMap = {
    success: { name: 'check', color: 'text-green-600' },
    error: { name: 'alert-circle', color: 'text-red-600' },
    warning: { name: 'alert-triangle', color: 'text-yellow-600' },
    info: { name: 'info', color: 'text-blue-600' },
    loading: { name: 'loading', color: 'text-gray-600' }
  };
  
  const config = statusMap[status] || statusMap.info;
  
  return (
    <Icon 
      name={config.name} 
      size={size} 
      className={`${config.color} ${config.name === 'loading' ? 'animate-spin' : ''} ${className}`} 
    />
  );
};

export default Icon;
